import { toaster } from 'uikit/Toaster'
import { useMutation } from '@tanstack/react-query'
import { api } from 'api'

export const useLunaSettingsUpdate = () => {
  return useMutation({
    mutationFn: (data: any) => api.luna.updateSettings(data.id, data),
    onError: () => {
      toaster.create({
        title: 'Ошибка',
        description: 'Не удалось обновить настройки Luna',
        type: 'error',
        duration: 9000,
        isClosable: true,
      })
    },
    onSuccess: () => {
      toaster.create({
        title: 'Готово',
        description: 'Настройки успешно обновлены',
        type: 'success',
      })
    }
  })
}
